import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useFormik } from 'formik'
import { pick, omit } from 'ramda'
import axios from 'axios'
import * as Yup from 'yup'

import { preparePhoneNumber } from 'utils'
import { orderFieldNames } from '../../../../constants'
import { API_URL } from 'src/config'
import OrderForOthersView from './View'

const mapStateToProps = state => ({
  authToken: state.user.authToken
})

export default connect(mapStateToProps)(OrderForOthersContainer)

function OrderForOthersContainer({
  city,
  authToken,
  onSubmitSuccess,
  onClickPreviousButton
}) {
  const [stateServerError, setServerError] = useState('')

  const formik = useFormik({
    initialValues: {
      [orderFieldNames.CITY]: city.id,
      [orderFieldNames.ADDRESS]: '',
      [orderFieldNames.OTHER_NAME]: '',
      [orderFieldNames.OTHER_LASTNAME]: '',
      [orderFieldNames.OTHER_PATRONYMIC]: '',
      [orderFieldNames.OTHER_KINSHIP]: '',
      [orderFieldNames.OTHER_PHONE]: '',
      [orderFieldNames.OTHER_EMAIL]: '',
      [orderFieldNames.OTHER_FAMILY_COUNT]: ''
    },

    validationSchema: Yup.object().shape({
      [orderFieldNames.ADDRESS]: Yup.string().required('Обязательное поле'),
      [orderFieldNames.OTHER_NAME]: Yup.string().required('Обязательное поле'),
      [orderFieldNames.OTHER_LASTNAME]: Yup.string().required('Обязательное поле'),
      [orderFieldNames.OTHER_PATRONYMIC]: Yup.string().required('Обязательное поле'),
      [orderFieldNames.OTHER_PHONE]: Yup.string().required('Обязательное поле'),
      [orderFieldNames.OTHER_KINSHIP]: Yup.string().required('Обязательное поле'),
      [orderFieldNames.OTHER_EMAIL]: Yup.string().email('Invalid email'),
      [orderFieldNames.OTHER_FAMILY_COUNT]: Yup.string().required('Обязательное поле')
    }),

    onSubmit: values => {
      const preparedValues = pick(
        [orderFieldNames.CITY, orderFieldNames.ADDRESS],
        values
      )

      preparedValues[orderFieldNames.OTHER] = omit(
        [orderFieldNames.CITY, orderFieldNames.ADDRESS],
        values
      )

      preparedValues[orderFieldNames.OTHER][orderFieldNames.OTHER_PHONE] =
        preparePhoneNumber(values[orderFieldNames.OTHER_PHONE])

      axios({
        method: 'post',
        url: `${API_URL}/order/another/`,
        data: {...preparedValues},
        headers: {
          'Authorization': `Token ${authToken}`
        }
      }).then(res => {
        if (onSubmitSuccess) {
          onSubmitSuccess()
          setServerError('')
        }
        // console.log(res)
      }).catch(err => {
        setServerError(err?.response?.data?.detail || 'Неизвестная ошибка')
        // console.error(err?.response)
      })

    }

  })

  return <OrderForOthersView
    values={formik.values}
    handleChange={formik.handleChange}
    handleSubmit={formik.handleSubmit}
    setFieldValue={formik.setFieldValue}
    formikBag={formik}
    errors={formik.errors}
    touched={formik.touched}
    onClickPreviousButton={onClickPreviousButton}
    cityName={city.name}
    serverError={stateServerError}
  />
}
